const phoneNumberRegex =
	/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

export const linkEnhancer = (url: string): string =>
	url.match(phoneNumberRegex) ? `tel:${url}` : url;
